@if (title || description) {
  <div
    class="info-banner d-flex align-items-center gap-2 p-3 border rounded-2"
    [class.info-banner--information]="mode === 'information'"
    [class.info-banner--warning]="mode === 'warning'"
    [attr.role]="mode === 'warning' ? 'alert' : 'status'">
    <i
      class="info-banner__icon fa-sm flex-shrink-0"
      [ngClass]="iconClass"
      aria-hidden="true"></i>

    <div class="d-flex flex-column justify-content-center flex-grow-1">
      @if (title) {
        <div class="info-banner__title fw-semibold mb-0">{{ title }}</div>
      }

      @if (description) {
        <div class="info-banner__description small mb-0">{{ description }}</div>
      }
    </div>
  </div>
}
